(() => {
  const fields = {name:'.opd-card-name',tungsten:'.opd-card-tungsten',facts:'.opd-card-facts-slot',vendor:'.grid-product__vendor',price:'.grid-product__price',rating:'.opd-card-rating-slot'};
  let frame = 0;
  const sizes = new WeakMap();
  const resize = new ResizeObserver(entries => {
    let changed = false;
    for (const entry of entries) {
      const width = Math.round(entry.contentRect.width * 10);
      if (sizes.get(entry.target) !== width) { sizes.set(entry.target, width); changed = true; }
    }
    if (changed) schedule();
  });
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  function update() {
    frame = 0;
    const groups = new Map();
    document.querySelectorAll('.opd-aligned-card').forEach(card => {
      if (!card.getClientRects().length || !card.offsetWidth) return;
      const parent = card.parentElement;
      if (!groups.has(parent)) groups.set(parent, new Map());
      const width = Math.round(card.getBoundingClientRect().width);
      const widths = groups.get(parent);
      if (!widths.has(width)) widths.set(width, []);
      widths.get(width).push(card);
      resize.observe(card);
      for (const key of [...Object.keys(fields), 'total']) card.style.setProperty('--opd-compact-' + key, '0px');
    });
    for (const widths of groups.values()) for (const cards of widths.values()) {
      const heights = {};
      for (const [key, selector] of Object.entries(fields)) {
        heights[key] = Math.ceil(Math.max(0, ...cards.map(card => card.querySelector(selector)?.getBoundingClientRect().height || 0)));
      }
      for (const card of cards) for (const [key, height] of Object.entries(heights)) card.style.setProperty('--opd-compact-' + key, height + 'px');
      const height = Math.ceil(Math.max(...cards.map(card => card.querySelector('.grid-product__content').getBoundingClientRect().height)));
      for (const card of cards) card.style.setProperty('--opd-compact-total', height + 'px');
    }
  }
  new MutationObserver(records => {
    if (records.some(record => record.target.nodeType === 1 && (record.target.closest('.opd-aligned-card') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.opd-aligned-card') || node.querySelector('.opd-aligned-card')))))) schedule();
  }).observe(document.body, {childList:true,subtree:true,characterData:true});
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  document.fonts?.ready.then(schedule);
  schedule();
})();